import { ChevronDownIcon } from "@primer/octicons-react";
import { ActionList, ActionMenu } from "@primer/react";

import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { khoiApi } from '../../api/khoiApi';
import { useCommonContext } from '../../contexts/common';
import { useCommonSelectedHook } from '../../hooks/useCommonSelectedHook';
import { dm_he } from '../../models/response/category/dm_he';
import { actions } from '../../state/actions/actionsWrapper';
import { RootState } from '../../state/reducers';
type ComboboxHeProps = {
	isReadonly?: boolean;
	disabled?: boolean;
	value?: number;
	onValueChanged: (id: number, data?: dm_he) => void;
	className?: string;
	isShowClearButton?: boolean;
	preText?: string;
	width?: string | number;
	dm_khoi_id?: number;
	dm_truong_id?: number;
	stylingMode?: 'outlined' | 'filled' | 'underlined';
};
const ComboboxHe = (props: ComboboxHeProps) => {
	const { translate } = useCommonContext();
	const { language } = useSelector((x: RootState) => x.common);
	const categorySource = useSelector((state: RootState) => state.categorySource);
	const dispatch = useDispatch();
	const [source, setSource] = useState<dm_he[]>([]);
	const [isLoading, setIsLoading] = useState(false);

	// Load all dm_hes for displaying selected value
	useEffect(() => {
		if (categorySource.dm_hes.length === 0) dispatch(actions.categorySource.loadHeStart());
	}, [categorySource.dm_hes.length, dispatch]);

	// Load hệ by khoi_id from API (similar to /khoi_he page)
	const loadHeByKhoi = useCallback(async (khoiId: number) => {
		if (!khoiId || khoiId === 0) {
			setSource([]);
			return;
		}

		try {
			setIsLoading(true);
			const res = await khoiApi.selectHe(khoiId);
			if (res && res.is_success) {
				setSource(Array.isArray(res.data) ? res.data : []);
			} else {
				setSource([]);
			}
		} catch (error) {
			console.error('ComboboxHe: Error loading hệ', error);
			setSource([]);
		} finally {
			setIsLoading(false);
		}
	}, []);

	// Load hệ when khoi_id changes
	useEffect(() => {
		if (props.dm_khoi_id && props.dm_khoi_id !== 0) {
			loadHeByKhoi(props.dm_khoi_id);
		} else {
			// If no khoi_id, show all dm_hes or filter by truong_id if possible
			if (categorySource.dm_hes.length > 0) {
				if (props.dm_truong_id && props.dm_truong_id !== 0) {
					const filtered = categorySource.dm_hes.filter(x => !x.dm_truong_id || x.dm_truong_id === props.dm_truong_id);
					setSource(filtered);
				} else {
					setSource(categorySource.dm_hes);
				}
			} else {
				setSource([]);
			}
		}
	}, [props.dm_khoi_id, props.dm_truong_id, categorySource.dm_hes, loadHeByKhoi]);

	// Reset selected value when khoi_id changes (but only if source is loaded and value is not in source)
	useEffect(() => {
		if (props.value && props.value !== 0 && props.dm_khoi_id && source.length > 0) {
			// Check if the currently selected he is in the new source
			const heExists = source.some(x => x.id === props.value);
			if (!heExists) {
				console.log('ComboboxHe: Resetting value because not in source', { value: props.value, source });
				props.onValueChanged(0);
			}
		}
	}, [props.dm_khoi_id, source, props.value]);
	const selectedData = useMemo(() => {
		console.log('ComboboxHe selectedData:', {
			value: props.value,
			dm_hes_count: categorySource.dm_hes.length,
			dm_hes: categorySource.dm_hes
		});

		if (props.value && categorySource.dm_hes.length > 0) {
			// Find from all dm_hes (not just filtered source) to display selected value correctly
			const found = categorySource.dm_hes.find(x => x.id === props.value);
			console.log('ComboboxHe found:', found);
			return found;
		}
		return undefined
	}, [categorySource.dm_hes, props.value])
	return (
		<ActionMenu >
			<ActionMenu.Button
				aria-label="Select school year"
				disabled={props.disabled || props.isReadonly}
				style={{
					width: '100%',
					display: 'flex',
					justifyContent: 'space-between',
					opacity: (props.disabled || props.isReadonly) ? 0.6 : 1,
					cursor: (props.disabled || props.isReadonly) ? 'not-allowed' : 'pointer',
				}}
				trailingAction={ChevronDownIcon}
				className="button-left"
			>
				{selectedData ? (language === "en" ? selectedData.ten_he_en : selectedData.ten_he) : (props.preText || translate("HeCombobox.PlaceHolder"))}
			</ActionMenu.Button>
			<ActionMenu.Overlay width="auto">
				<ActionList selectionVariant="single">
					{props.isShowClearButton &&
						<ActionList.Item key={0} selected={props.value !== undefined && 0 === props.value}
							onSelect={() => {
								props.onValueChanged(0)
							}}
						>
							{language === "en" ? "Chọn hệ" : "Chọn hệ"}
						</ActionList.Item>
					}
					{source && source.map((item) => {
						return (
							<ActionList.Item key={item.id} selected={props.value !== undefined && item.id === props.value}
								onSelect={() => {
									props.onValueChanged(item.id)
								}}
							>
								{language === "en" ? item.ten_he_en : item.ten_he}
							</ActionList.Item>
						);
					})}
				</ActionList>

			</ActionMenu.Overlay>
		</ActionMenu >
		// <Select onChange={(e) => {
		// 	const dm_he_id: number = e.currentTarget.value ? parseInt(e.currentTarget.value) : 0
		// 	props.onValueChanged(dm_he_id, source.find(x => x.id == dm_he_id))
		// }}
		// 	value={`${props.value ?? 0}`}
		// 	placeholder={translate("HeCombobox.PlaceHolder")}
		// >
		// 	{source.map(x => {
		// 		return (
		// 			<Select.Option key={x.id} value={`${x.id}`}>{language === "en" ? x.ten_he_en : x.ten_he}</Select.Option>
		// 		);
		// 	})}
		// </Select>

	);
};
export default ComboboxHe;
